import React from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../../assets/logos/logo-forager-white.svg';

function NavegationDesktop({ style }) {
  return (
    <header className={`bg-dark-denim/50 ${style}`}>
      <div className="xl:container mx-auto px-24 lg:px-8 pb-5 pt-6 flex justify-between items-center">
        <NavLink to="/">
          <img src={Logo} alt="Logo Forager Media Group" className="w-32" />
        </NavLink>
        <nav className="text-white">
          <ul className="app-nav-desktop-links flex gap-6 lg:gap-10">
            <li>
              <NavLink to="/">
                home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about">
                about
              </NavLink>
            </li>
            <li>
              <NavLink to="/companies">
                companies
              </NavLink>
            </li>
            <li>
              <NavLink to="/our-team">
                our team
              </NavLink>
            </li>
            <li>
              <NavLink to="/working-at-forager">
                working at forager
              </NavLink>
            </li>
            <li>
              <NavLink to="/news">
                news
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact">
                contact
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default NavegationDesktop;
